import classnames from "classnames";
import { useCallback, useState } from "react";
import { OnResizeCallback, useResizeDetector } from "react-resize-detector";
import GlobalSearchFilters from "./GlobalSearchFilters.component";
import GlobalSearchTotals from "./GlobalSearchTotals.component";

export const ROOT_PATH = "/";
export const INVESTMENT_PATHS = [
  "/investments",
  "/notes",
  "/documents",
  "/portfolios",
  "/knowledgeBase",
];
export const COMPANY_PATHS = ["/company"];
export const ENGAGEMENT_PATHS = ["/engagementsSearch"];
export const pathsWithGlobalSearch = [
  ROOT_PATH,
  ...INVESTMENT_PATHS,
  ...COMPANY_PATHS,
  ...ENGAGEMENT_PATHS,
];

// Pages that render global search results themselves. Deliberately not derived
// from INVESTMENT_PATHS: /knowledgeBase drives its own search state and ignores
// the global search filters, so a search submitted there has to navigate away.
const SEARCH_RESULT_PATHS = [
  "/investments",
  "/notes",
  "/documents",
  "/portfolios",
  ...COMPANY_PATHS,
  ...ENGAGEMENT_PATHS,
];

/**
 * Whether the given path applies the global search filters to its own results.
 * Submitting a search from one of these pages keeps the user there; anywhere
 * else has to navigate to a page that shows the results.
 */
export const rendersGlobalSearchResults = (pathname: string) =>
  SEARCH_RESULT_PATHS.includes(pathname);

function GlobalSearchControls() {
  const [filterHeight, setFilterHeight] = useState<number>(145);

  const onResize: OnResizeCallback = useCallback(({ height }) => {
    if (typeof height === "number" && height > 0) {
      setFilterHeight(height);
    }
  }, []);

  const { ref } = useResizeDetector({
    onResize,
    handleHeight: true,
    handleWidth: false, // Only need height
    refreshMode: "debounce",
    refreshRate: 100,
  });

  return (
    <div
      className="p-relative"
      style={{
        height: filterHeight ? `${filterHeight}px` : "auto",
        minHeight: filterHeight ? `${filterHeight}px` : undefined,
      }}
    >
      <div ref={ref} className={classnames("main-gf")}>
        <GlobalSearchTotals />
        <GlobalSearchFilters />
      </div>
    </div>
  );
}

export default GlobalSearchControls;
